import axios from 'axios';
const API = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost/api',
  paramsSerializer: params => {
    const parts = [];
    for (const [k, v] of Object.entries(params)) {
      if (Array.isArray(v)) v.forEach(val => parts.push(`${encodeURIComponent(k)}[]=${encodeURIComponent(val)}`));
      else if (v != null) parts.push(`${encodeURIComponent(k)}=${encodeURIComponent(v)}`);
    }
    return parts.join('&');
  },
});
API.interceptors.request.use(c => { const t = localStorage.getItem('hm_token'); if(t) c.headers.Authorization = `Bearer ${t}`; return c; });
API.interceptors.response.use(r => r, e => {
  const url = e.config?.url || '';
  const isAuthEndpoint = /\/auth\/(login|register|forgot-password|reset-password|verify-reset-token)/.test(url);
  if (e.response?.status === 401 && !isAuthEndpoint) {
    // If we're mid-impersonation the imp token has just expired or been
    // invalidated. Restore the admin token (cached at session start) and
    // route back to the support console instead of nuking everything.
    const adminToken = localStorage.getItem('hm_token_admin');
    const adminUser  = localStorage.getItem('hm_user_admin');
    if (adminToken) {
      try {
        localStorage.setItem('hm_token', adminToken);
        if (adminUser) localStorage.setItem('hm_user', adminUser);
        localStorage.removeItem('hm_token_admin');
        localStorage.removeItem('hm_user_admin');
        localStorage.removeItem('hm_imp_meta');
      } catch { /* ignore */ }
      window.location.href = '/admin/support';
      return Promise.reject(e);
    }
    localStorage.clear(); window.location.href = '/login';
  }
  return Promise.reject(e);
});
export default API;
